module.exports = __webpack_public_path__ + "static/media/design.a1c9a820.png";